import {
  FeatureCta,
  FeatureDetailSection,
  FeatureHero,
  FeaturePageShell,
} from "./_Shell";

export default function BooksAnswersTransfers() {
  return (
    <FeaturePageShell>
      <FeatureHero
        title="More than an answering service"
        subtitle="Your AI receptionist answers your FAQs, takes a message when you're busy, and transfers urgent calls to a real person instantly."
      />

      <div className="max-w-3xl mx-auto px-6 space-y-6 pb-8">
        <FeatureDetailSection
          icon="ri-calendar-check-line"
          title="Takes messages when you're busy"
          description="Callers leave a message and your team gets it by text or email right away, with the caller's name and number."
        />
        <FeatureDetailSection
          icon="ri-question-answer-line"
          title="Answers your FAQs"
          description="Train your AI with your most common questions — hours, pricing, services, policies. It answers confidently and accurately every time."
        />
        <FeatureDetailSection
          icon="ri-phone-fill"
          title="Transfers the calls that matter"
          description="When a call needs a human, your AI transfers it immediately — screened or direct. Urgent situations never fall through the cracks."
        />
      </div>

      <FeatureCta headline="See it in action. Book a demo." />
    </FeaturePageShell>
  );
}
